import { render, staticRenderFns } from "./DeliveryTeamShell.vue?vue&type=template&id=571e5b4b"
import script from "./DeliveryTeamShell.vue?vue&type=script&lang=js"
export * from "./DeliveryTeamShell.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports